import {fill} from 'lodash'

const statusCompany = [
  {id: 1, name: 'Active'},
  {id: 2, name: 'Not renewed'},
  {id: 3, name: 'Managed by client'},
  {id: 4, name: 'Managed by partner'},
  {id: 5, name: 'Under liquidation'},
  {id: 6, name: 'Liquidated'}
]

const visaMaxValue = 30

const visaQuote = fill(Array(visaMaxValue + 1), 1).map((item, index) => {
  const val = index
  return {
    id: val,
    name: val
  }
})

export {statusCompany, visaQuote}



// WEBPACK FOOTER //
// ./src/constants/contactCompany.js